import { NgModule } from '@angular/core';
import { SwitchMultiCasePipe } from './switch-multi-case.pipe';

@NgModule({
  declarations: [SwitchMultiCasePipe],
  exports: [SwitchMultiCasePipe],
})
export class SwitchMultiCasePipeModule {}
